import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-black/40 border-b border-white/10 text-white py-2 px-4 text-center text-sm font-medium tracking-wide" data-id="element-15">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center items-center gap-x-6 gap-y-1" data-id="element-16">
        <span className="flex items-center gap-2" data-id="element-17">
          <span data-id="element-18">⚡</span> Acceso en 5 min
        </span>
        <span className="hidden sm:inline opacity-50" data-id="element-19">•</span>
        <span className="flex items-center gap-2" data-id="element-20">
          <span data-id="element-21">🛡️</span> Garantía 7 días
        </span>
        <span className="hidden sm:inline opacity-50" data-id="element-22">•</span>
        <span className="flex items-center gap-2" data-id="element-23">
          <span data-id="element-24">🇦🇷</span> Para Argentina
        </span>
      </div>
    </div>;
}